import React from 'react';
import '../../styles/Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { useI18n } from '../../../i18n/I18nProvider';
import qrImage from '../../../images/Footer/JidduFilms_img_footer-qr.png';

const Footer = () => {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Footer Bottom - Minimalist */}
      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-content">
            {/* QR Code Section */}
            <div className="footer__qr-section">
              <div className="footer__qr-image">
                <img src={qrImage} alt={t('footer.qrAlt')} className="footer__qr-code" />
              </div>
              <div className="footer__qr-text">
                <div className="footer__qr-text-line">{t('footer.qrText1')}</div>
                <div className="footer__qr-text-line">{t('footer.qrText2')}</div>
              </div>
            </div>


            {/* Social Media Icons */}
            <div className="footer__social">
              <a href="https://www.instagram.com/jiddufilms/" className="footer__social-link" target="_blank" rel="noopener noreferrer">
                <div className="footer__social-icon">
                  <FontAwesomeIcon icon={faInstagram} />
                </div>
              </a>
              <a href="https://youtube.com/@jiddufilms2577?si=ga47lSibYi--4kMm" className="footer__social-link" target="_blank" rel="noopener noreferrer">
                <div className="footer__social-icon">
                  <FontAwesomeIcon icon={faYoutube} />
                </div>
              </a>
              <a href="https://tiktok.com" className="footer__social-link" target="_blank" rel="noopener noreferrer">
                <div className="footer__social-icon">
                  <FontAwesomeIcon icon={faTiktok} />
                </div>
              </a>
            </div>
          </div>
          {/* Slim divider and credits */}
          <div className="footer__divider" />
          <div className="footer__credits">
            <div className="footer__credits-left">
              <span className="visually-hidden">
                {t('footer.developedBy')} <a href="https://www.altovalleit.com" target="_blank" rel="noopener noreferrer">AltoValleIT</a>
              </span>
            </div>
            <div className="footer__credits-right">
              <a href="/privacy-policy" className="footer__legal-link">{t('footer.privacyPolicy')}</a>
              <span className="footer__separator">|</span>
              <a href="/terms" className="footer__legal-link">{t('footer.terms')}</a>
              <span className="footer__separator">|</span>
              <a href="/login" className="footer__legal-link">{t('footer.login')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
